export const TopBar = () => (
  <div className="bg-navy text-center text-[13px] tracking-[.3px] text-teal py-[7px]">
    <a href="mailto:hello@peoplegroupservices.com" className="hover:underline">
      hello@peoplegroupservices.com
    </a>
    &nbsp;|&nbsp;
    <a href="tel:+443450341530" className="hover:underline">
      0345 034 1530
    </a>
  </div>
);
